import React from 'react'
import UploadImage from './UploadImage'
import DetailsFields from './DetailsFields'
import './index.styl'
import Buttons from './Buttons'
import PublishInfoBox from './PublishInfoBox'

const Header = ({ form, currentEventDetails }) => {
  return (
    <div className='headerContainer'>
      <div className='headerWrapper'>
        <div className='upload-details-wrapper'>
          <div className='leftColumn'>
            <div className='headerTitle'>{currentEventDetails && 'Edit Event' || 'Create New Event'}</div>
            <div className='imgBtnWrapper'>
              <UploadImage />
              <Buttons currentEventDetails={currentEventDetails} form={form} />
            </div>
          </div>
          <div className='rightColumn'>
            <PublishInfoBox />
            <DetailsFields currentEventDetails={currentEventDetails} form={form} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
